export default __webpack_public_path__ + "static/media/09A.40.1757285e.png";